import { getFormPayload } from "@routes/Keyword/templates/AseanInsights/components/DownloadForm/actions/helpers/getFormPayload";
import { sendDataToEmarsys } from "@routes/Keyword/templates/AseanInsights/components/DownloadForm/actions/helpers/sendDataToEmarsys";
import { submitFormSchema } from "@routes/Keyword/templates/AseanInsights/components/DownloadForm/actions/utils/schema";
import { z } from "zod";

/** Action to submit the form. */
const actionSubmitForm = async (
  _prevState: AseanIntelligenceSubmitState,
  formData: FormData
): Promise<AseanIntelligenceSubmitState> => {
  const legalConsent = formData.get("legalConsent") === "on";
  const newsletterConsent =
    formData.get("newsletterConsent") === "on" ? true : false;

  const validatedFields = submitFormSchema.safeParse({
    name: formData.get("name"),
    email: formData.get("email"),
    sector: formData.get("sector"),
    country: formData.get("country"),
    seniority: formData.get("seniority"),
    otherSector: formData.get("otherSector"),
    legalConsent: legalConsent,
  });

  if (!validatedFields.success) {
    const stringFields = Object.fromEntries(
      [...formData.entries()].filter(
        (entry): entry is [string, string] => typeof entry[1] === "string"
      )
    );

    return {
      success: false,
      message: "Form submission failed!",
      errors: z.flattenError(validatedFields.error).fieldErrors,
      fields: stringFields,
    };
  }

  const { email, name, sector, country, seniority, otherSector } =
    validatedFields.data as {
      email: string;
      name: string;
      sector: string;
      country: string;
      seniority: string;
      otherSector: string;
    };

  const payload = await getFormPayload({
    email,
    name,
    sector,
    country,
    seniority,
    otherSector,
    newsletterConsent,
  });

  const response = await sendDataToEmarsys(email, payload);

  if (!response.success) {
    return {
      success: false,
      message: "Form submission failed!",
      errors: {},
      fields: {},
    };
  }

  return {
    success: true,
    message: "Form submitted successfully!",
  };
};

export default actionSubmitForm;
